
import { Autocomplete, Box, Button, ButtonGroup, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Toolbar, Tooltip, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { toast } from "react-toastify";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { getFormattedDates } from "../../utils/utils";
import { DateisValid, parseRange } from "../../utils/components/accuracyandlcandrangesshow";


const ExternalCalibrationList = () => {
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "DUCID");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [totalRows, setTotalRows] = React.useState(0);
  const [data, setFinalData] = React.useState([]);
  const [searched, setSearched] = React.useState(false);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const urlPath = useLocation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const isClient = _userType == 3;

  const getQuery = (count) => {
    const conditions = [];
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      const colName = {
        "Client Name": "c.companyName",
        "Instrument Name": "i.instrumentName",
        DUCID: "ec.ducId",
        "Serial No": "ec.serialNumber",
        "Certificate Number": "ec.certificateNumber",
        "ULR NO": "ec.ulrNo",
      }[searchBy];
      if (colName) {
        conditions.push(`LOWER(${colName}) like LOWER('%${searchKey}%')`);
      }
    }

    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      conditions.push(`ec.calibrationDate between '${fromDate}' and '${toDate}'`);
    }

    // client login: only his own data
    if (isClient) {
      conditions.push(`ec.clientId = ${Number(_clientId)}`);
    }

    const whereConditions = conditions.length
      ? ` where ${conditions.join(" and ")} `
      : "";

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${rowsPerPage * Number(page)
        }`;
    }

    const joins = `FROM externalCalibration ec
      LEFT JOIN clients c ON ec.clientId = c.id
      LEFT JOIN addresses a ON ec.address = a.id
      LEFT JOIN instruments i ON ec.instrumentId = i.id`;

    if (count) {
      return {
        query: `SELECT COUNT(*) AS no_of_rows ${joins} ${whereConditions}`,
      };
    }

    return {
      query: `SELECT ec.*, c.companyName, a.address as companyAddress, i.instrumentName ${joins} ${whereConditions} order by ec.id DESC ${pagination_settings}`,
    };
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(err.message);
        }
      });
  }

  function fetchFinalData() {
    getTotalRows();
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("srfs data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(err.message);
        }
      });
  }

  const handleDelete = (id) => {
    const confirmed = window.confirm(
      "Really want to delete externalCalibration?"
    );
    if (!confirmed) {
      return;
    }
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `externalCalibration/${id}`)
      .then((res) => {
        toast("externalCalibration is deleted!");
        setTimeout(refresh, 500);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(err.message);
        }
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

 const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const formatCell = (columnId, value) => {
    if (columnId === "entryDate" && value) {
      return new Date(value).toLocaleDateString("en-GB");
    }
    return value;
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    fetchFinalData();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    // sessionStorage.removeItem("currentPath");
    setSearchKey("");
    setSearchBy("DUCID");
    setFrom(null);
    setTo(null);
    setSearched(false);
    fetchFinalData();
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  useEffect(() => {
    if (searched == false) {
     fetchFinalData();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [rowsPerPage, page, searched]);

  return (
    <div style={{ padding: "10px" }}>
      {!isClient && (
      <Toolbar id="externalCalibration" className="ListCreatebutton">
        <Button
          variant="contained"
          size="small"
          component={Link}
          to="/externalCalibrationList/editExternalCalibration/0"
          sx={{
            ":hover": {
              color: "#fff",
            },
          }}
        >
          <b>create External Calibration</b>
        </Button>
      </Toolbar>
      )}
      <br />

      <Grid
        container
        spacing={1}
        alignItems="center"
        style={{ padding: "5px 0px", marginBottom: "2px", width: "100%" }}
      >
        <Grid item xs={12} sm={6} md={2} lg={2} id="ducMaster_list_searchby">
          <Autocomplete
            sx={{ m: 0, minWidth: 0, width: "100%" }}
            className="Listinputcss"
            size="small"
            value={searchBy}
            options={
              _userType != 3
                ? [
                  { key: "c.companyName", label: "Client Name" },
                  { key: "i.instrumentName", label: "Instrument Name" },
                  { key: "ec.ducId", label: "DUCID" },
                  { key: "ec.serialNumber", label: "Serial No" },
                  { key: "ec.certificateNumber", label: "Certificate Number" },
                  { key: "ec.ulrNumber", label: "ULR NO" },
                ]
                : [
                  { key: "i.instrumentName", label: "Instrument Name" },
                  { key: "ec.ducId", label: "DUCID" },
                  { key: "ec.serialNumber", label: "Serial No" },
                  { key: "ec.certificateNumber", label: "Certificate Number" },
                  { key: "ec.ulrNumber", label: "ULR NO" },                ]
            }
            renderInput={(params) => (
              <TextField {...params} label="Search By" fullWidth />
            )}
            onInputChange={(event, newInputValue) => {
              setSearchBy(newInputValue);
              setSearched(false);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <TextField
            className="Listinputcss"
            id="ducMaster_list_searchbytext"
            label={"enter " + searchBy}
            size="small"
            inputProps={{ autoComplete: "off" }}
            value={searchKey}
            variant="outlined"
            onChange={(e) => {
              setSearchKey(e.target.value);
              setSearched(false);
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={1.5} id="srflist-datefrom">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: { size: "small", fullWidth: true },
              }}
              className="Listinputcss"
              label="From"
              value={from ? new Date(from) : null}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setFrom(newValue);
                setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={1.5} id="srflist-dateto">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: { size: "small", fullWidth: true },
              }}
              className="Listinputcss"
              label="To"
              value={to ? new Date(to) : null}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setTo(newValue);
                setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={3} md={1} lg={0.5} textAlign="left">
          <Button
            id="ducMaster_list_searchbtn"
            variant="contained"
            size="small"
            color={searched ? "error" : "primary"}
            onClick={() => {
              searched ? clearSearch() : search();
            }}
            sx={{ minWidth: { xs: "100%", sm: "40px" } }}
          >
            {searched ? <RestartAltIcon /> : <SearchIcon />}
          </Button>
        </Grid>
      </Grid>

       <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
       <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
        <Table stickyHeader aria-label="sticky table" size="small"  className="table-responsive"
            id="certificate-certificatelisttable"
            sx={{ borderCollapse: "collapse",
          
          }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Sr.No.</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Client</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Service Request Number</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Certificate Number</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>ULR No</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Instrument Name</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Range</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Least Count</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>DUC ID</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Serial Number</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Model</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Date of Calibration</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Due Date</b></TableCell>
              <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap", padding: "5px" }}><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length > 0 ? (
              data.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  <TableCell align="left">
                    {page * rowsPerPage + (index + 1)}
                  </TableCell>
                  <TableCell>{row.companyName}</TableCell>
                  <TableCell>{row.serviceReqNumber}</TableCell>
                  <TableCell>{row.certificateNumber}</TableCell>
                  <TableCell>{row.ULRNo}</TableCell>
                  <TableCell>{row.instrumentName}</TableCell>
                  <TableCell>{parseRange(row.ranges)}</TableCell>
                  <TableCell>{parseRange(row.lc)}</TableCell>
                  <TableCell>{row.ducId}</TableCell>
                  <TableCell>{row.serialNumber}</TableCell>
                  <TableCell>{row.model}</TableCell>
                  <TableCell>{DateisValid(row.calibrationDate)}</TableCell>
                  <TableCell>{DateisValid(row.dueDate)}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small" aria-label="small button group">
                      {!isClient && (
                        <Tooltip title="Edit External Calibration" placement="top-start">
                          <Button
                            component={Link}
                            to={`/externalCalibrationList/editExternalCalibration/${row.id}`}
                          >
                            <PreviewIcon />
                          </Button>
                        </Tooltip>
                      )}
                      <Tooltip title="View Certificate" placement="top-start">
                        <Button
                          onClick={() => {
                            if (row.certificateFile) {
                              window.open(row.certificateFile, "_blank");
                            } else {
                              toast.error("Certificate file not found!");
                            }
                          }}
                        >
                          <ReceiptLongIcon />
                        </Button>
                      </Tooltip>
                      {!isClient && (
                        <Tooltip title="Delete External Calibration" placement="top-start">
                          <span>
                            <Button
                              disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                              onClick={() => handleDelete(row.id)}
                            >
                              <DeleteIcon
                                style={{
                                  color: !(editAccess?.includes(2) || editAccess?.includes(0))
                                    ? "lightgray"
                                    : "#dc3545",
                                }}
                              />
                            </Button>
                          </span>
                        </Tooltip>
                      )}
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <h6>
                    <b>Data Not Found</b>
                  </h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 30, 50, 100]}
        component="div"
        count={totalRows || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
      </Box>
    </div>
  );
};

export default ExternalCalibrationList;
